import React from "react";
import styled from "styled-components";
import { AiOutlineMenu } from "react-icons/ai";
import { MdClose } from "react-icons/md";

const Container = styled.div`
  display: none;
  color: #000;
  cursor: pointer;
  z-index: 999;
  @media screen and (max-width: 767.9px) {
    display: flex;
    align-self: center;
    order: 1;
    top: 4px;
    right: 0;
    font-size: 1.8rem;
    cursor: pointer;
    }
`

export default function ToggleBar(props) {
  return (
  <Container className={"toggler-bar"+ (props.className ? props.className : '')}>
    {props.expanded ? 
    <MdClose  onClick={props.fncToggleNavBar}></MdClose>
    :
    <AiOutlineMenu onClick={props.fncToggleNavBar}></AiOutlineMenu>}
  </Container>
  )
}
